import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {ConstantsService} from './constants.service';
import {QuotationListInfoModel} from '../models/quotation-list-info.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {CarBodyQuotationDetail, MechanicQuotationDetail} from '../models/quotation-details.model';
import {Injectable, Injector} from '@angular/core';
import {QuotationHistoryModel} from '../models/quotation-history.model';
import {Observable, Subject, throwError} from 'rxjs';
import {Parts} from '../../authority-op/models/quotation.model';
import {RequestOptions, RequestOptionsArgs, Response} from '@angular/http';
import {InnerMessageAuthorityMessageCode,} from './inner-message-authority-utilities';
import {CommonMessageCode, MessageCodeAndComponentType, MessageComponentType, MessageDetail, MessageType} from '@shared/service/message-manager/message.model';
import {MessageManagerUtilities} from '@shared/service/message-manager/message-manager-utilities';
import {AuthorityBaseService} from './authority-base.service';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {UploadFileService} from '@shared/service/upload-file.service';
import {catchError, first, map, tap} from 'rxjs/operators';
import {PermissionService} from '@shared/service/permission.service';
import {NemoModuleKeys, UserPermissionsModel} from '@shared/models/user-permission.model';
import {UserV3Model} from '@shared/models/user-v-3.model';
import {CommodityModel} from '@shared/models/commodity.model';
import { TranslateContext, TranslatePipe } from '@shared/pipes/translate.pipe';
import { DossierModel } from '../models/dossier.model';
import { DossierHistoryModel } from '../models/dossier-history.model';
import { AUTHORITY_ADMIN_USER, AUTHORITY_IT_ADMIN_USER, AUTHORITY_OPERATOR_USER, AUTHORITY_SUPERVISOR_USER, AUTHORITY_TECH_SERVICES_OPERATOR_USER, AuthorityUsersPermissions } from '../../../../app/permissions-variables';
import { sleep } from '@app/shared/utilities/utilities-function';

@Injectable({
	providedIn: 'root'
})
export class QuotationService extends AuthorityBaseService {
	innerAuthorityMessagesCodeMap: Map<QuotationServiceActionType, MessageCodeAndComponentType> = new Map<QuotationServiceActionType, MessageCodeAndComponentType>([
		[QuotationServiceActionType.APPROVE, {messageCode: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_QUOTATION_AUTHORIZED, componentType: MessageComponentType.FLASH_MESSAGE}],
		[QuotationServiceActionType.RE_APPROVE, {messageCode: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_QUOTATION_AUTHORIZED, componentType: MessageComponentType.FLASH_MESSAGE}],
		[QuotationServiceActionType.SUPER_APPROVE, {messageCode: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_QUOTATION_AUTHORIZED, componentType: MessageComponentType.FLASH_MESSAGE}],
		[QuotationServiceActionType.DECLINE, {messageCode: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_QUOTATION_DECLINED, componentType: MessageComponentType.FLASH_MESSAGE}],
		[QuotationServiceActionType.RE_DECLINE, {messageCode: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_QUOTATION_DECLINED, componentType: MessageComponentType.FLASH_MESSAGE}],
		[QuotationServiceActionType.SUPER_REJECT, {messageCode: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_QUOTATION_DECLINED, componentType: MessageComponentType.FLASH_MESSAGE}],
		[QuotationServiceActionType.SEND, {messageCode: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_SEND_QUOTATION, componentType: MessageComponentType.FLASH_MESSAGE}],
		[QuotationServiceActionType.SEND_SUPERVISOR, {messageCode: InnerMessageAuthorityMessageCode.GENERIC_SUCCESS, componentType: MessageComponentType.FLASH_MESSAGE}],
		[QuotationServiceActionType.CANCEL_SUPER_REJECT, {messageCode: InnerMessageAuthorityMessageCode.GENERIC_SUCCESS, componentType: MessageComponentType.FLASH_MESSAGE}],
		[QuotationServiceActionType.SUPER_DECLINE, {messageCode: InnerMessageAuthorityMessageCode.GENERIC_SUCCESS, componentType: MessageComponentType.FLASH_MESSAGE}],
		[QuotationServiceActionType.BILL_WITHOUT_LAST_INTEGRATION, {messageCode: InnerMessageAuthorityMessageCode.GENERIC_SUCCESS, componentType: MessageComponentType.FLASH_MESSAGE}],
		[QuotationServiceActionType.REJECT, {messageCode: InnerMessageAuthorityMessageCode.GENERIC_SUCCESS, componentType: MessageComponentType.FLASH_MESSAGE}]
	]);
	isSuperUser: boolean;
	private readonly prefix: string;
	private changePartsSubject: Subject<{ entries: string[], entriesParts: Parts[] }> = new Subject<{ entries: string[], entriesParts: Parts[] }>();

	constructor(
		protected injector: Injector,
		private constantsService: ConstantsService,
		private selectCommoditiesService: SelectCommoditiesService,
		public permissionService: PermissionService,
		private uploadFileService: UploadFileService,
		private translatePipe: TranslatePipe,
		private snackBar: MatSnackBar
	) {
		super(injector);
		this.prefix = constantsService.getPrefix();
		this.isSuperUser = this.permissionService.getCurrentUserPermissions().isCenterSuperUserOperator(NemoModuleKeys.AUTHORITY);
	}

	getCommodities(): string[] {
		// return AuthorityUtilities.getCommodities(this.permissionService);
		return this.selectCommoditiesService.getCurrentCommodities().map(commodity => commodity.id);
	}
	
	// getBaseURL(dossier?: DossierModel | DossierHistoryModel): string {
	// 	return dossier && dossier.isArchived() ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1;
	// }
	getBaseURL(x?: boolean | DossierModel | DossierHistoryModel): string {

		if (Utilities.isEmpty(x) || x === false) {
			return this.environment.api.authority.v1;
		}

		if (x == true) {
			return this.environment.api.authority.historical.v1;
		}
		
		if (x instanceof DossierModel || x instanceof DossierHistoryModel) {
			return x && x.isArchived() ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1;
		}
		
		return this.environment.api.authority.v1;
	}

	async quotationServiceDoPatch(
		dossier_id: string, working_id: string, quotationID: string, type: QuotationServiceActionType,
		onSuccess: (message: MessageDetail) => void, onFailure: (message: MessageDetail) => void, declineBody?: DeclineBody, 
		claims_dissociated?: boolean
	): Promise<void> {

		// MOCK
		// per testare la dialog del Rifiuto Definitivo
		// evita di fare la bonifica e riportare la pratica allo stato precedente
		// await sleep(4000);
		// onSuccess({
		// 	type: MessageType.TYPE_SUCCESS,
		// 	code: this.innerAuthorityMessagesCodeMap.get(type).messageCode,
		// 	componentType: this.innerAuthorityMessagesCodeMap.get(type).componentType
		// });
		// return;

		const url: string = `${this.environment.AUTHORITY}${this.prefix}/dossiers/${dossier_id}/workings/${working_id}/quotations/${quotationID}/${type}` + 
		((): string => {

			if (claims_dissociated === false) {
				return '';
			}

			if ([QuotationServiceActionType.SUPER_REJECT, QuotationServiceActionType.REJECT].includes(type)) {
				return `?claims_dissociated=true`;
			}
			
			return '';
		})();
		
		this.httpAuthService.patch(url, declineBody, this.redirectUrl).pipe(first()).subscribe(
			(response) => {
				if (response.ok) {
					onSuccess({
						type: MessageType.TYPE_SUCCESS,
						code: this.innerAuthorityMessagesCodeMap.get(type).messageCode,
						componentType: this.innerAuthorityMessagesCodeMap.get(type).componentType
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			}, (error) => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	// ---------------------------------------------------------------------------------------------
	// COMMON
	// ---------------------------------------------------------------------------------------------

	getQuotationsById(
		// operationID: string, 
		dossier: DossierModel, 
		workingId: string,
		onSuccess: (response: QuotationListInfoModel) => void,
		onFailure?: (message: MessageDetail) => void
	): void {
		// const url: string = this.environment.AUTHORITY + this.prefix + '/dossiers/' + operationID + '/workings/' + workingId + '/quotations/active';
		const url: string = this.getBaseURL(dossier) + this.prefix + '/dossiers/' + dossier.id + '/workings/' + workingId + '/quotations/active';
		let options: RequestOptions = new RequestOptions();
		if (this.isSuperUser) {
			const commodities: string[] = this.selectCommoditiesService.getAllIDs();
			options = Utilities.setOptionsWithNemoCommodityID(commodities);
		} else {
			// const arrayCommodities: string[] = [];
			// const commodities: CommodityModel[] = this.permissionService.getCommoditiesFromItemMenuID(UserV3Model.AUTHORITY_ITEM_MENU_ID);
			// commodities.forEach((commodity) => {
			// 	arrayCommodities.push(commodity.id);
			// });
			// options = Utilities.setOptionsWithNemoCommodityID(arrayCommodities);
			options = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		}

		this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						onSuccess(new QuotationListInfoModel(response.json()));
					} catch (error) {
						onFailure({
							code: CommonMessageCode.GENERIC_ERROR,
							type: MessageType.TYPE_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getDetailsForMechanic(
		// operationId: string, 
		dossier: DossierModel,
		quotationId: string, 
		commodities: string, 
		workingId: string,
		onSuccess: (quotation: MechanicQuotationDetail) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = this.environment.AUTHORITY + this.prefix + '/dossiers/' + operationId + '/workings/' + workingId + '/quotations/' + quotationId + '/mechanic';
		const url = this.getBaseURL(dossier) + this.prefix + '/dossiers/' + dossier.id + '/workings/' + workingId + '/quotations/' + quotationId + '/mechanic';
		
		const comms: CommodityModel[] = this.permissionService.getCommoditiesFromItemMenuID(UserV3Model.AUTHORITY_ITEM_MENU_ID);
		const arrayCommodities: string[] = [];
		comms.forEach((comm) => {
			arrayCommodities.push(comm.id);
		});
		// const options: any = Utilities.setOptionsWithNemoCommodityID(arrayCommodities);
		const options: any = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						onSuccess(new MechanicQuotationDetail(response.json()));
					} catch (error) {
						onFailure({
							code: CommonMessageCode.GENERIC_ERROR,
							type: MessageType.TYPE_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getDetailsForCarBody(
		// operationId: string, 
		dossier: DossierModel,
		quotationId: string, 
		commodity: string, 
		workingId: string,
		onSuccess: (quotation: CarBodyQuotationDetail) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = this.environment.AUTHORITY + this.prefix + '/dossiers/' + operationId + '/workings/' + workingId + '/quotations/' + quotationId + '/carbody';
		const url = this.getBaseURL(dossier) + this.prefix + '/dossiers/' + dossier.id + '/workings/' + workingId + '/quotations/' + quotationId + '/carbody';
		
		const commodities: CommodityModel[] = this.permissionService.getCommoditiesFromItemMenuID(UserV3Model.AUTHORITY_ITEM_MENU_ID);
		const arrayCommodities: string[] = [];
		commodities.forEach((comm) => {
			arrayCommodities.push(comm.id);
		});
		// const options: any = Utilities.setOptionsWithNemoCommodityID(arrayCommodities);
		const options: any = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						onSuccess(new CarBodyQuotationDetail(response.json()));
					} catch (error) {
						onFailure({
							code: CommonMessageCode.GENERIC_ERROR,
							type: MessageType.TYPE_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getDeletedEntries(
		dossier: DossierModel,
		quotationId: string, 
		workingId: string
	): Observable<any> {
		// const url: string = this.environment.AUTHORITY + this.prefix + '/dossiers/' + dossierId + '/workings/' + workingId + '/quotations/' + quotationId + '/deleted';
		const url = this.getBaseURL(dossier) + '/dossiers/' + dossier.id + '/workings/' + workingId + '/quotations/' + quotationId + '/deleted';
		const commodities: CommodityModel[] = this.permissionService.getCommoditiesFromItemMenuID(UserV3Model.AUTHORITY_ITEM_MENU_ID);
		const arrayCommodities: string[] = [];
		commodities.forEach((comm) => {
			arrayCommodities.push(comm.id);
		});
		// const options: any = Utilities.setOptionsWithNemoCommodityID(arrayCommodities);
		const options: any = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		return this.httpAuthService.get(url, this.redirectUrl, options).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json()),
			catchError((error: Response) => {
					this.messageManagerService.pushInnerMessage(MessageManagerUtilities.getMessageDetailsFromResponse(error));
					return throwError(error);
				}
			)
		);
	}

	// ---------------------------------------------------------------------------------------------
	// OPERATORE CENTRO
	// ---------------------------------------------------------------------------------------------

	getNewIframeUrl(
		body: any, 
		dossier: DossierModel,
		maintenanceType: string, 
		working_id: string,
		onSuccess: (response: any) => void, 
		onFailure: (message: MessageDetail) => void
	): void {
		// /api/v1/dossiers/{dossier_id}/workings/{working_id}/quotations
		// let url: string = this.environment.AUTHORITY + this.prefix + '/dossiers/' + dossier_id + '/workings/' + working_id + '/quotations';
		let url = this.getBaseURL(dossier) + this.prefix + '/dossiers/' + dossier.id + '/workings/' + working_id + '/quotations';
		const type: any = {quotation_type: maintenanceType};
		url = url + Utilities.getQuery(type);
		const commodities: string[] = this.selectCommoditiesService.getAllIDs();
		// const options: RequestOptionsArgs = Utilities.setOptionsWithNemoCommodityID(commodities);
		const options: RequestOptionsArgs = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		options.headers.set('Content-Type', 'application/json');
		this.httpAuthService.post(url, body, this.redirectUrl, options).subscribe(
			response => {
				try {
					// @ts-ignore
					const _body: any = JSON.parse(response._body);
					if (response.ok && _body.quotation_url) {
						onSuccess(_body);
					} else {
						onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
					}
				} catch (error) {
					onFailure({
						code: CommonMessageCode.GENERIC_ERROR,
						type: MessageType.TYPE_ERROR,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				}
			}, error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	deleteQuotation(
		dossier: DossierModel,
		quotationID: string, 
		working_id: string,
		onSuccess: (successMessage: MessageDetail) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = this.environment.AUTHORITY + this.prefix + '/dossiers/' + dossier_id + '/workings/' + working_id + '/quotations/' + quotationID;
		const url = this.getBaseURL(dossier) + this.prefix + '/dossiers/' + dossier.id + '/workings/' + working_id + '/quotations/' + quotationID;
		this.httpAuthService.delete(url, this.redirectUrl).subscribe(
			() => {
				onSuccess({
					code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_QUOTATION_DELETED,
					type: MessageType.TYPE_SUCCESS,
					componentType: MessageComponentType.FLASH_MESSAGE
				});
			}, (error) => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	editIframe(
		body: any, 
		dossier: DossierModel,
		quotationID: string, 
		maintenanceType: string, 
		working_id: string,
		onSuccess: (response: any) => void, 
		onFailure: (message: MessageDetail) => void
	): void {
		// let url: string = `${this.environment.AUTHORITY}${this.prefix}/dossiers/${dossier_id}/workings/${working_id}/quotations/${quotationID}`;
		let url = `${this.getBaseURL(dossier)}${this.prefix}/dossiers/${dossier.id}/workings/${working_id}/quotations/${quotationID}`;

		const type: any = {quotation_type: maintenanceType};
		url = url + Utilities.getQuery(type);
		const commodities: string[] = this.selectCommoditiesService.getAllIDs();
		// const options: RequestOptionsArgs = Utilities.setOptionsWithNemoCommodityID(commodities);
		const options: RequestOptionsArgs = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		options.headers.set('Content-Type', 'application/json');
		this.httpAuthService.put(url, body, this.redirectUrl, options).subscribe(
			response => {
				this.handleResponse(response, onSuccess, onFailure);
			}, error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	integrateIframe(
		body: any, 
		dossier: DossierModel,
		quotationID: string, 
		maintenanceType: string, 
		working_id: string,
		onSuccess: (response: any) => void, 
		onFailure: (message: MessageDetail) => void
	): void {
		// let url: string = `${this.environment.AUTHORITY}${this.prefix}/dossiers/${dossier_id}/workings/${working_id}/quotations/${quotationID}/integration`;
		let url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${working_id}/quotations/${quotationID}/integration`;
		
		const type: any = {quotation_type: maintenanceType};
		url = url + Utilities.getQuery(type);
		const commodities: string[] = this.selectCommoditiesService.getAllIDs();
		// const options: RequestOptionsArgs = Utilities.setOptionsWithNemoCommodityID(commodities);
		const options: RequestOptionsArgs = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		options.headers.set('Content-Type', 'application/json');
		this.httpAuthService.post(url, body, this.redirectUrl, options).subscribe(
			response => {
				this.handleResponse(response, onSuccess, onFailure);
			}, error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getQuotationHistory(
		dossier: DossierHistoryModel,
		working_id: string, 
		type: string, 
		isConsultation: boolean,
		onSuccess: (entries: QuotationHistoryModel[]) => void, 
		onFailure: (message: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossier_id}/workings/${working_id}/quotations/${isConsultation ? 'consultation' : 'history'}/${type}`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${working_id}/quotations/${isConsultation ? 'consultation' : 'history'}/${type}`;

		const commodities: CommodityModel[] = this.permissionService.getCommoditiesFromItemMenuID(UserV3Model.AUTHORITY_ITEM_MENU_ID);
		const arrayCommodities: string[] = [];
		commodities.forEach((comm) => {
			arrayCommodities.push(comm.id);
		});
		// const options: any = Utilities.setOptionsWithNemoCommodityID(arrayCommodities);
		const options: any = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						// @ts-ignore
						const responseBody: any = JSON.parse(response._body).entries;
						const entries: QuotationHistoryModel[] = [];
						responseBody.forEach(entry => {
							entries.push(new QuotationHistoryModel(entry));
						});
						onSuccess(entries);
					} catch (e) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					if (response.status !== 404) {
						onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
					}
				}
			}, error => {
				if (error.status !== 404) {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
				}
			}
		);
	}

	getChangePartsSubject(): Subject<{ entries: string[], entriesParts: Parts[] }> {
		return this.changePartsSubject;
	}

	protected handleResponse(response: any, onSuccess: (response: any) => void, onFailure: (message: MessageDetail) => void): void {
		try {
			const _body: any = JSON.parse(response._body);
			if (response.ok && _body.quotation_url) {
				onSuccess(_body);
			} else {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
			}
		} catch (error) {
			onFailure({
				type: MessageType.TYPE_ERROR,
				code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
				componentType: MessageComponentType.FLASH_MESSAGE
			});
		}
	}

	downloadWoePdf(
		dossier: DossierModel,
		workingId: string, 
		quotationId: string, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${workingId}/quotations/${quotationId}/woe_document`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${workingId}/quotations/${quotationId}/woe_document`;

		this.httpAuthService.get(url, this.redirectUrl).subscribe(
			response => {
				this.privateDownloadFile(response.json());
			}, error => onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error))
		);
	}

	privateDownloadFile(value: any): void {
		this.uploadFileService.downloadAttachedFile(value.uuid).subscribe(
			response => {
				if (!Utilities.isVoid(response)) {
					Utilities.downloadFile(response, value.file_name);
				} else {
					const config: MatSnackBarConfig = new MatSnackBarConfig();
					config.duration = 2000;
					config.panelClass = ['snack-bar-error'];
					this.snackBar.open(this.translatePipe.transform('IMPOSSIBILE_SCARICARE_L_ALLEGATO', TranslateContext.SHARED), '', config);
				}
			}, () => {
				const config: MatSnackBarConfig = new MatSnackBarConfig();
				config.duration = 2000;
				config.panelClass = ['snack-bar-error'];
				this.snackBar.open(this.translatePipe.transform('IMPOSSIBILE_SCARICARE_L_ALLEGATO', TranslateContext.SHARED), '', config);
			});
	}

	removeQuotationParts(
		dossier: DossierModel,
		working_id: string, 
		quotation_id: string, 
		entries: string[], 
		isConsip: boolean
	): Observable<Response> {
		// `${this.environment.AUTHORITY + this.prefix}/dossiers/${dossier_id}/workings/${working_id}/quotations/${quotation_id}/entries/${isConsip ? 'c_flow_removed' : 'removed'}`,
		const url = `${this.getBaseURL(dossier) + this.prefix}/dossiers/${dossier.id}/workings/${working_id}/quotations/${quotation_id}/entries/${isConsip ? 'c_flow_removed' : 'removed'}`;
		return this.httpAuthService.patch(url, {entries_id: entries}, this.redirectUrl).pipe(
			tap(
				response => {
					if (!response.ok) {
						throw response;
					}
				}
			),
			catchError(
				(error: Response) => {
					this.messageManagerService.pushInnerMessage(
						{
							...MessageManagerUtilities.getMessageDetailsFromResponse(error),
							...{
								componentType: MessageComponentType.SNACK_BAR
							}
						}
					);
					return throwError(error);
				}
			)
		);
	}

	removeOrderParts(order_id: string, entries: string[]): Observable<Response> {
		return this.httpAuthService.patch(
			`${this.environment.AUTHORITY + this.prefix}/orders/${order_id}/entries/removed`,
			{entries_id: entries},
			this.redirectUrl
		).pipe(
			tap(
				response => {
					if (!response.ok) {
						throw response;
					}
				}
			),
			catchError(
				(error: Response) => {
					this.messageManagerService.pushInnerMessage(
						{
							...MessageManagerUtilities.getMessageDetailsFromResponse(error),
							...{
								componentType: MessageComponentType.SNACK_BAR
							}
						}
					);
					return throwError(error);
				}
			)
		);
	}

	/**
	 * Determina se l'utente può forzare il refresh della stima del preventivo.
	 * L'azione è permessa solo se:
	 *  - l'utente ha uno dei profili abilitati (allowedProfile)
	 *  - l'utente ha il permesso authority_quotations_write
	 *  - lo stato della working NON è tra quelli vietati (notAllowedQuotationStatus)
	 *
	 * @param profile Il modello dei permessi utente correnti
	 * @param workingStatus Lo stato attuale dell preventivo
	 * @returns true se l'utente può forzare il refresh, false altrimenti
	 */
	canForceQuotationRefresh(profile: UserPermissionsModel, workingStatus:string): boolean {
		// Profili abilitati all'azione
		const allowedProfile = [
			AUTHORITY_ADMIN_USER, 
			AUTHORITY_OPERATOR_USER,                               
			AUTHORITY_IT_ADMIN_USER, 
			AUTHORITY_SUPERVISOR_USER, 
			AUTHORITY_TECH_SERVICES_OPERATOR_USER
		]
		// Stati che NON permettono il refresh
		const notAllowedQuotationStatus = [
			'CLOSED',
			'C_FLOW_REJECTED',
			'DECLINED',
			'INTEGRATION_TO_SEND',
			'REJECTED',
			'RE_DECLINED',
			'SUPERVISOR_REJECTED',
			'TO_SEND',
			'WAITING_FOR_REFRESH',
			'WAITING_FOR_UNFREEZE'
		];
		const userProfileKey = profile.getCurrentProfile().key;
		const hasRequiredPermission = profile.hasPermissions(AuthorityUsersPermissions.authority_quotations_write) 
		// Deve avere il profilo giusto, il permesso giusto e NON essere in uno stato vietato
    	return (
			allowedProfile.includes(userProfileKey) && 
			hasRequiredPermission && 
			!notAllowedQuotationStatus.includes(workingStatus)
		)			
	}

	/**
	 * Forza il refresh della stima del preventivo per una specifica working e quotazione.
	 * Esegue una chiamata GET all'endpoint di refresh e gestisce la risposta tramite callback.
	 *
	 * @param dossier Il modello del dossier corrente
	 * @param workingId L'ID della working su cui forzare il refresh
	 * @param quotationId L'ID del preventivo da aggiornare
	 * @param onSuccess Callback chiamata in caso di successo, riceve un MessageDetail
	 * @param onFailure Callback chiamata in caso di errore, riceve un MessageDetail
	*/
	forceQuotationRefresh(
		dossier: DossierModel,
		workingId: string,
		quotationId: string,
		onSuccess: (successMessage: MessageDetail) => void,
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// /api/authority/api/v1/dossiers/{dossier_id}/workings/{working_id}/quotations/{quotation_id}/refresh
		const url: string = this.getBaseURL(dossier) + this.prefix
			+ '/dossiers/' + dossier.id
			+ '/workings/' + workingId
			+ '/quotations/' + quotationId
			+ '/refresh';
		this.httpAuthService.get(url, this.redirectUrl).subscribe(
			response => {
				if (response.status === 204) {
					onSuccess({
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_FORCE_QUOTATION_REFRESH,
						type: MessageType.TYPE_SUCCESS,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			});
	}

}

export interface DeclineBody {
	declined_note: string;
	rejection_type?: string;
	cluster?: string;
	cluster_description?: string;
}


export enum QuotationServiceActionType {
	RE_DECLINE = 're_decline',
	DECLINE = 'decline',
	SEND = 'send',
	APPROVE = 'approve',
	RE_APPROVE = 're_approve',
	SUPER_APPROVE = 'super_approve',
	SUPER_REJECT = 'super_reject',
	SEND_SUPERVISOR = 'send_supervisor',
	SUPER_DECLINE = 'super_decline',
	CANCEL_SUPER_REJECT = 'cancel_super_reject',
	BILL_WITHOUT_LAST_INTEGRATION = 'c_flow_bill',
	REJECT = 'reject'
}
